import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formMsg, setFormMsg] = useState("");

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get("phone_alt") as string || "").trim();
    if (honeypotValue) {
      setFormStatus("success");
      setFormMsg("消息已发送，我们会尽快回复！");
      form.reset();
      return;
    }

    try {
      const payload = new URLSearchParams();
      payload.append("name", formData.get("name") as string);
      payload.append("email", formData.get("email") as string);
      payload.append("subject", formData.get("subject") as string);
      payload.append("message", formData.get("message") as string);

      const res = await fetch("http://i0767.com/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      const parsed = JSON.parse(responseText);

      if (res.ok && parsed?.code === "OK") {
        setFormStatus("success");
        setFormMsg("消息已发送，我们会尽快回复！");
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || "发送失败";
        setFormStatus("error");
        setFormMsg(serverMsg);
      }
    } catch {
      setFormStatus("error");
      setFormMsg("网络错误，请稍后重试");
    }
  };

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <section className="py-12 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">关于我们</span>
            </nav>

            <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
              <div className="lg:w-[40%]">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-background-300 text-xs text-foreground-600 mb-6">
                  关于汗汗
                </div>
                <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20cozy%20manga%20reading%20space%20with%20bookshelves%20filled%20with%20colorful%20comic%20books%2C%20warm%20ambient%20lighting%20from%20desk%20lamps%2C%20comfortable%20reading%20chairs%2C%20artistic%20manga%20posters%20on%20the%20wall%2C%20peaceful%20atmosphere%2C%20clean%20and%20inviting%2C%20high%20detail%20interior%20photography&width=800&height=600&seq=about-brand-image&orientation=landscape"
                    alt="汗汗漫画 - 关于我们"
                    title="汗汗漫画品牌形象"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="lg:w-[60%] flex flex-col justify-center">
                <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-foreground-900 tracking-tight leading-tight">
                  汗汗漫画<br />更新最快的漫画网
                </h1>
                <p className="mt-5 text-sm text-foreground-500 leading-relaxed max-w-lg">
                  汗汗漫画成立于2020年，是国内领先的免费漫画在线阅读平台。我们以&ldquo;更新速度最快&rdquo;为核心优势，致力于为广大漫画爱好者提供海量优质漫画资源和极致流畅的阅读体验。
                </p>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-lg">
                  平台汇聚超过50,000部漫画资源，涵盖热血、恋爱、玄幻、耽美、恐怖、搞笑、韩漫、国漫、日漫等九大品类。我们坚持无遮挡、无删减的原汁原味呈现方式，让每一位读者都能享受到最完整的漫画内容。
                </p>
                <div className="mt-6">
                  <a
                    href="#contact-section"
                    className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-foreground-900 text-white text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-mail-line"></i>
                    联系我们
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
              <div className="lg:w-[60%]">
                <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-8">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500 mr-2"></span>
                  品牌声誉
                </p>
                <blockquote>
                  <p className="font-serif text-xl md:text-2xl text-foreground-900 leading-relaxed italic">
                    &ldquo;汗汗漫画追求在内容时效性和阅读体验上做到极致。我们深知每一位漫画爱好者等待更新的心情，因此打造了业内领先的内容同步系统，确保新章节发布后第一时间呈现给读者。&rdquo;
                  </p>
                </blockquote>
                <div className="mt-5 flex items-center gap-3">
                  <span className="text-sm font-bold text-foreground-900 font-heading">汗汗漫画团队</span>
                  <span className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs">
                    <i className="ri-shield-check-line text-xs"></i>
                    用户至上 · 内容为王
                  </span>
                </div>
              </div>

              <div className="lg:w-[40%]">
                <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20editorial%20black%20and%20white%20portrait%20of%20an%20Asian%20creative%20professional%2C%20profile%20view%2C%20confident%20expression%2C%20modern%20casual%20attire%2C%20pure%20white%20background%2C%20clean%20minimal%20composition%2C%20high%20contrast%2C%20editorial%20photography%20style&width=600&height=800&seq=about-team-portrait&orientation=portrait"
                    alt="汗汗漫画团队"
                    title="汗汗漫画团队成员"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-900 tracking-tight">
                我们的优势
              </h2>
              <p className="mt-3 text-sm text-foreground-500">为什么选择汗汗漫画？</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-flashlight-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold text-foreground-900 font-heading">极速更新</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                  业内领先的内容同步系统，新章节发布后第一时间呈现，比同类平台快2-6小时
                </p>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-book-open-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold text-foreground-900 font-heading">海量资源</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                  超过50,000部漫画，涵盖九大品类，日漫韩漫国漫一网打尽
                </p>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-eye-line text-2xl text-secondary-500"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold text-foreground-900 font-heading">无遮挡阅读</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                  坚持原汁原味呈现，不删减不遮挡，给你最完整的漫画阅读体验
                </p>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-shield-check-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold text-foreground-900 font-heading">永久免费</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                  基础阅读功能永久免费，无需付费即可畅享全部漫画资源
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-background-100" id="contact-section">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-900 tracking-tight">
                  联系我们
                </h2>
                <p className="mt-3 text-sm text-foreground-500">
                  有任何问题或建议？欢迎随时联系我们
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
                <div className="text-center p-5 bg-background-50 rounded-xl">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <p className="mt-3 text-sm font-semibold text-foreground-900 font-heading">商务合作</p>
                  <p className="mt-1 text-xs text-foreground-500">hello@i0767.com</p>
                </div>

                <div className="text-center p-5 bg-background-50 rounded-xl">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-customer-service-2-line text-xl text-accent-500"></i>
                  </div>
                  <p className="mt-3 text-sm font-semibold text-foreground-900 font-heading">用户支持</p>
                  <p className="mt-1 text-xs text-foreground-500">hello@i0767.com</p>
                </div>

                <div className="text-center p-5 bg-background-50 rounded-xl">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100">
                    <i className="ri-briefcase-line text-xl text-secondary-500"></i>
                  </div>
                  <p className="mt-3 text-sm font-semibold text-foreground-900 font-heading">加入我们</p>
                  <p className="mt-1 text-xs text-foreground-500">hello@i0767.com</p>
                </div>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <h3 className="text-lg font-bold text-foreground-900 font-heading mb-6">发送消息</h3>
                <form
                  id="contact-form"
                 
                  onSubmit={handleContactSubmit}
                  className="flex flex-col gap-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-xs text-foreground-500 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                        placeholder="你的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-xs text-foreground-500 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                        placeholder="你的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-xs text-foreground-500 mb-1.5">主题</label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                      placeholder="消息主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs text-foreground-500 mb-1.5">消息内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent resize-none"
                      placeholder="请输入你的消息（最多500字）"
                    ></textarea>
                  </div>
                  <div className="honeypot-field">
                    <input name="phone_alt" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <button
                    type="submit"
                    className="self-start px-8 py-3 rounded-xl bg-foreground-900 text-white text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-send-plane-line mr-2"></i>
                    发送消息
                  </button>
                  {formStatus !== "idle" && (
                    <p className={`text-xs ${formStatus === "success" ? "text-primary-600" : "text-secondary-600"}`}>
                      {formMsg}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于汗汗漫画 - 更新最快的漫画网",
            "description": "汗汗漫画成立于2020年，是国内领先的免费漫画在线阅读平台，以更新速度最快为核心优势，提供海量免费漫画资源。",
            "url": "http://i0767.com/about",
            "inLanguage": "zh-Hans",
            "isPartOf": {
              "@type": "WebSite",
              "name": "汗汗漫画",
              "url": "http://i0767.com/"
            },
            "about": {
              "@type": "Organization",
              "name": "汗汗漫画",
              "url": "http://i0767.com/",
              "description": "汗汗漫画-更新最快的漫画网，提供好看的免费漫画大全和无遮挡韩漫",
              "foundingDate": "2020",
              "contactPoint": [
                {
                  "@type": "ContactPoint",
                  "contactType": "customer support",
                  "email": "hello@i0767.com"
                },
                {
                  "@type": "ContactPoint",
                  "contactType": "business cooperation",
                  "email": "hello@i0767.com"
                }
              ]
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "http://i0767.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "关于我们",
                "item": "http://i0767.com/about"
              }
            ]
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "汗汗漫画是什么时候成立的？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "汗汗漫画成立于2020年，经过多年发展已成为国内领先的免费漫画在线阅读平台，拥有超过50,000部漫画资源和800万活跃读者。"
                }
              },
              {
                "@type": "Question",
                "name": "汗汗漫画的核心优势是什么？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "汗汗漫画的核心优势包括：极速更新（新章节比同类平台快2-6小时）、海量资源（超过50,000部漫画）、无遮挡阅读（不删减不遮挡）、永久免费（基础阅读功能永久免费）。"
                }
              },
              {
                "@type": "Question",
                "name": "如何联系汗汗漫画？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "您可以通过以下方式联系汗汗漫画：hello@i0767.com，hello@i0767.com，hello@i0767.com。也可以通过网站上的联系表单发送消息。"
                }
              }
            ]
          }),
        }}
      />
    </>
  );
}